var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"activity-words"},[_c('div',{class:{
      'activity-words__wrap': true,
      'activity-words__wrap--column': _vm.onePerLine,
    }},_vm._l((_vm.computedWords),function(word){return _c('ActivityTextButton',{key:word.id,attrs:{"bg-color":word.active ? '#86c040' : '#f3aa45'}},[_vm._v(" "+_vm._s(word.value)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }